import css from 'styled-jsx/css';

const styles = css`:root {
  /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */
  --black: #000000;
  --dark-gray: #b3b3b3;
  --error: red;
  --success: #248647;
  --green: green;
  --lightgreen: lightgreen;
  --gray-1: #787778;
  --gray-2: #bbbbbb;
  --gray-2-5: #d8d8d8;
  --gray-3: #eeeeee;
  --gray-4: #f8f8f8;
  --gray-5: #fafafa;
  --gray-6: #ebebeb;
  --gray-footer: #4f4f4f;
  --gray-footer-text: #757575;
  --gray-black: #111111;
  --heading-gray: #505050;
  --border-gray: #c8c8c8;
  --gray-background: rgba(0, 0, 0, 0.2);
  --warning: #daaa00;

  --mmr-yellow: #f8e71c;
  --mmr-red: #b41f00;
  --module-gray: #f7f7f7;
  --module-white: #ffffff;
  --primary-bg: #eeeeee;
  --clear: transparent;

  --risk-high: #e37a00;
  --risk-low: #7c993f;
  --risk-med: #ffcc00;
  --text-fg: #3b3b3b;
  --text-header: #4c5a6a;
  --tooltip-header: #4c5a69;
  --warm-grey: #898989;
  --white: #ffffff;
  --border-line: #b8b8b8;
  --orange-button: #e17a17;

  --text-dark: #3b3b3b;
  --text-med: #4f4f4f;
  --text-light: #898989;
  --text-xlight: #c4c4c4;
  --text-disabled: #b1b1b1;

  --subtle-blue-gray: #f7f9fa;
  --trp-dark-blue: #004b71;
  --trp-light-blue: #eef7fa;
  --trp-bright-blue: #05c3de;
  --ice-blue: #24c0d8;
  --row-blue: #06c3df;
  --trp-dark-blue: #0063ad;
  --dark-blue: #054c70;
  --dark-blue-2: #043954;
  --navy-blue: #0a4c71;
  --trp-nav-dark-blue: #061937;
  --trp-bottom-footer-blue: #0c2a4d;
  --trp-link-blue: #80c8ff;
  --trp-tag-blue: #00cfec;

  --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

  /* NASU Specifc Colors */
  /* TODO [2020-08-05]: change these colors to EDDS approved colors if they are not already */
  --BYOP-header-grey: #f0f3f5;
  --BYOP-header-contents-grey: #f7f9fa;

  /* 2020 colors */
  --primary-blue: #086ea1;
  --brand-interactive-blue: #006894;
  --grey-text: #475359;
  --gray-back: #f1f1f1;
  --gray-morningstar: #6b7880;
  --gray-non-rated-star: #b4babf;
  --gray-risk-reward-bar: #e9edf0;
  --green-risk-reward-thumb: #7d9845;
  --yellow-risk-reward-thumb: #ffcf3d;
  --orange-risk-reward-thumb: #e17a17;
  --gray-header-bottom-border: #879199;
  --gray-disabled-button: #e1e5e8;
  --border-white: #d3d7da;
  --link-blue: #006894;
  --qv-header-bottom-border: #d7dbde;
  --required-error-msg: #cc1f1f;
  --no-funds-error-msg: #dd3636;

  /* Beacon colors */
  --beacon-primary: #8b57d9;
  --input-field-title: #3b4b59;
  --background-blue: #253746;
}
:root {
  --page-max-width: 1230px;
  --page-padding: 32px;
  --module-gutter: 24px;
  --half-gutter: calc(var(--module-gutter) / 2);
  --quarter-gutter: calc(var(--half-gutter) / 2);
  --module-padding: 24px;
  --mobile-padding: 4px;
  --min-content: min-content;

  /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
  --element-spacing-1: 8px;
  --element-spacing-2: calc(var(--element-spacing-1) * 2);
  --element-spacing-3: calc(var(--element-spacing-1) * 3);
  --element-spacing-4: calc(var(--element-spacing-1) * 4);
  --element-spacing-5: calc(var(--element-spacing-1) * 5);
  --element-spacing-6: calc(var(--element-spacing-1) * 6);
  --element-spacing-7: calc(var(--element-spacing-1) * 7);
  --element-spacing-8: calc(var(--element-spacing-1) * 8);
  --element-spacing-9: calc(var(--element-spacing-1) * 9);
  --element-spacing-10: calc(var(--element-spacing-1) * 10);
  --element-spacing-11: calc(var(--element-spacing-1) * 11);

  --border-thin-width: 1px;
  --border-width: 2px;
  --border-radius: 5px;

  /* New II Design Pattern - Introduced 11-12-2019 */
  --page-focus-width: 544px;
  --help-focus-width: 328px;
}
:root {
  --xxxsmall-font: 10px;
  --xxsmall-font: 12px;
  --xsmall-font: 14px;
  --small-font: 16px;
  --med-font: 18px;
  --large-font: 20px;
  --xlarge-font: 24px;
  --xxlarge-font: 36px;
  --xxxlarge-font: 48px;
  --title-font: 18px;
  --label-sup-font: 100%;

  --h1-font: 32px;
  --h2-font: 20px;
  --p1: 16px;
  --p2: 14px;
  --caption-size: 12px;

  --h1-font-mobile: 24px;
  --h2-font-mobile: 18px;
  --p1-mobile: 16px;
  --p2-mobile: 14px;
  --caption-size-mobile: 12px;

  --roboto-flex-font: 'Roboto Flex', sans-serif;
  --sans-novus: 'Roboto Flex Novus';
  --condensed-font: 'Roboto Flex Condensed', 'Roboto Flex', sans-serif;
  --condensed-bold: 'Roboto Flex Condensed Bold', 'Roboto Flex Condensed',
    sans-serif;
  --serif-font: 'IBM Plex Serif', serif;
  --mono-font: 'Roboto Flex', sans-serif;

  --roboto-reg: 'Roboto Flex Reg', sans-serif;
  --roboto-italic: 'Roboto Flex Italic', sans-serif;
  --roboto-bold: 'Roboto Flex Bold', sans-serif;
  --roboto-light: 'Roboto Flex', sans-serif;
  --roboto-black: 'Roboto Flex Black', sans-serif;

  --rocky-reg: 'Rocky Reg', sans-serif;
  --rocky-light: 'Rocky Light', sans-serif;

  --regular-weight: 400;
  --bold-weight: 700;
  --light-weight: 100;
  --normal-weight: normal;

  --checkbox-height: 25px;
  --checkbox-width: 25px;
}
:root {
  --filter-width-btn-expanded: 145px;
  --auto-suggest-width: 340px;
  --media-autosuggest-input-padding: 0 var(--element-spacing-2);
}
.filters-wrapper {
  display: flex;
  margin-top: 0;
}
.filters-wrapper :global(.autosuggest-input) {
  min-width: 340px;
  padding-top: 8px;
  padding-left: calc(8px * 10);
}
.expand-filter-view :global(button)::before {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.9644 0.21525C17.9026 0.084 17.7706 0 17.6251 0H0.374844C0.229342 0 0.0973403 0.084 0.0354645 0.21525C-0.0260362 0.346875 -0.00653601 0.502125 0.0860901 0.613875L7.49993 9.57825V17.625C7.49993 17.832 7.66756 18 7.87493 18H10.125C10.3323 18 10.5 17.832 10.5 17.625V9.57825L17.9138 0.613875C18.0068 0.502125 18.0259 0.346875 17.9644 0.21525Z' fill='%23006894'/%3E%3C/svg%3E");
  top: 3px;
  position: relative;
  padding-right: 8px;
}
.expand-filter-view.active :global(button)::before {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.9644 0.21525C17.9026 0.084 17.7706 0 17.6251 0H0.374844C0.229342 0 0.0973403 0.084 0.0354645 0.21525C-0.0260362 0.346875 -0.00653601 0.502125 0.0860901 0.613875L7.49993 9.57825V17.625C7.49993 17.832 7.66756 18 7.87493 18H10.125C10.3323 18 10.5 17.832 10.5 17.625V9.57825L17.9138 0.613875C18.0068 0.502125 18.0259 0.346875 17.9644 0.21525Z' fill='%23ffffff'/%3E%3C/svg%3E");
}
.expand-filter-view :global(button)::after {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='7' viewBox='0 0 14 7' fill='none'%3E%3Cpath d='M7.00065 7L3.41715e-07 2.70244e-07L14 -9.53674e-07L7.00065 7Z' fill='%23006894'/%3E%3C/svg%3E");
  bottom: 2px;
  left: calc(8px * 2);
  position: relative;
}
.expand-filter-view.active :global(button)::after {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='7' viewBox='0 0 14 7' fill='none'%3E%3Cpath d='M7.00065 7L3.41715e-07 2.70244e-07L14 -9.53674e-07L7.00065 7Z' fill='%23ffffff'/%3E%3C/svg%3E");
  left: 8px;
}
.expand-filter-view.expanded :global(button)::after {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='7' viewBox='0 0 14 7' fill='none'%3E%3Cpath d='M7.00065 7L3.41715e-07 2.70244e-07L14 -9.53674e-07L7.00065 7Z' fill='%23006894' transform='rotate%28-179.99998474121094 7.000000476837158%2C3.499999523162842%29'/%3E%3C/svg%3E");
}
.expand-filter-view.expanded.active :global(button)::after {
  content: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='7' viewBox='0 0 14 7' fill='none'%3E%3Cpath d='M7.00065 7L3.41715e-07 2.70244e-07L14 -9.53674e-07L7.00065 7Z' fill='%23ffffff' transform='rotate%28-179.99998474121094 7.000000476837158%2C3.499999523162842%29'/%3E%3C/svg%3E");
  left: 8px;
}
.search-filter-view {
  display: flex;
  margin-top: calc(8px * 5);
}
.search-filter-view :global(.autosuggest-input) {
  min-width: 340px;
  padding-top: 0;
  padding-left: calc(8px * 10);
}
.filter-btn {
  background-color: #ffffff;
  border-radius: 5px;
  border: 1px solid #086ea1;
  padding: 8px;
  line-height: 22px;
  color: #086ea1;
  font-weight: normal;
  width: 145px;
  height: calc(8px * 5);
}
.filter-btn:hover {
  cursor: pointer;
}
.filter-btn.active {
  background-color: #086ea1;
  color: #ffffff;
  /* background-color: var(--white);
  color: var(--primary-blue); */
  border: 1px solid #086ea1;
  border-radius: 5px;
}
.filterbtn-fundinfo {
  display: flex;
}
.mobile-only {
  display: none;
}
.desktop-only {
  display: block;
}
@media (min-width: 322px) and (max-width: 720px) {
  .filters-wrapper {
    flex-wrap: wrap;
  }
  .filters-wrapper :global(.autosuggest-input) {
    padding: 0 calc(8px * 2);
  }
  .search-filter-view {
    flex-direction: column;
  }
  .search-filter-view :global(.autosuggest-input) {
    min-width: 340px;
    padding: 0;
    margin: calc(8px * 2);
  }
  .mobile-only {
    display: block;
  }
  .desktop-only {
    display: none;
  }
  .filterbtn-fundinfo {
    flex-direction: column;
  }
}
`;

export default styles;